
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6397"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6397"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3ueMA", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $289fa3fab82a0cd6$export$6503ec6e8aabbaf; }, function (v) { return $289fa3fab82a0cd6$export$6503ec6e8aabbaf = v; });
var $289fa3fab82a0cd6$export$6503ec6e8aabbaf;
var $289fa3fab82a0cd6$export$f7ad0328861e2f03;
"use strict";
var $289fa3fab82a0cd6$var$mapping = new Map();
function $289fa3fab82a0cd6$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$289fa3fab82a0cd6$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $289fa3fab82a0cd6$var$resolve(id) {
    var resolved = $289fa3fab82a0cd6$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$289fa3fab82a0cd6$export$6503ec6e8aabbaf = $289fa3fab82a0cd6$var$register;
$289fa3fab82a0cd6$export$f7ad0328861e2f03 = $289fa3fab82a0cd6$var$resolve;

});

parcelRegister("1VgMz", function(module, exports) {
document.querySelector(".btn.btn-hamburger").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.remove("hide");
});
document.querySelector(".btn.navigationDrawer--closeBtn").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.add("hide");
});
document.querySelectorAll('[data-element="navItem-expander"]').forEach((el)=>{
    el.querySelector(".navigationDrawer--navItemBtn").addEventListener("click", (e)=>{
        if (el.querySelector(".navigationDrawer--navItemExpanded").classList.contains("hide")) {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.remove("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "180deg";
        } else {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.add("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "0deg";
        }
    });
});

});

parcelRegister("eZzoa", function(module, exports) {
const $aea236adfe947986$var$btnTopNavigationEls = document.querySelectorAll(".btn.link-item");
const $aea236adfe947986$var$navigationMegaDropdownEl = document.querySelector(".navigationMegaDropdown");






const $aea236adfe947986$var$setValueDropDownNavigation = (keyElement)=>{
    const dropdownNavigation = {
        services: [
            {
                pageUrl: "intelligent-finance.html",
                logoSrc: new URL((parcelRequire("dEKS9"))),
                title: "Intelligent Finance Function"
            },
            {
                pageUrl: "manage-payroll.html",
                logoSrc: new URL((parcelRequire("1ICF9"))),
                title: "Managed Payroll"
            },
            {
                pageUrl: "consulting.html",
                logoSrc: new URL((parcelRequire("62f2s"))),
                title: "Consulting"
            }
        ],
        products: [
            {
                pageUrl: "people-management.html",
                logoSrc: new URL((parcelRequire("7QJiP"))),
                title: "People Management"
            },
            {
                pageUrl: "power-insight.html",
                logoSrc: new URL((parcelRequire("7EaWj"))),
                title: "Power Insight"
            },
            {
                pageUrl: "all-product.html",
                logoSrc: new URL((parcelRequire("lXlin"))),
                title: "All Product"
            }
        ]
    };
    $aea236adfe947986$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn").forEach((el, index)=>index > 0 && el.remove());
    dropdownNavigation[keyElement].forEach((value)=>{
        const navigationMegaDropdownBtn = $aea236adfe947986$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdownBtn").cloneNode(true);
        navigationMegaDropdownBtn.href = value.pageUrl;
        navigationMegaDropdownBtn.querySelector('[data-element="logoNavigation"]').src = value.logoSrc;
        navigationMegaDropdownBtn.querySelector('[data-element="titleNavigation"]').textContent = value.title;
        $aea236adfe947986$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdown--inner").appendChild(navigationMegaDropdownBtn);
    });
    $aea236adfe947986$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn")[0].remove();
};
$aea236adfe947986$var$btnTopNavigationEls.forEach((el)=>{
    el.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $aea236adfe947986$var$navigationMegaDropdownEl.style.display = "flex";
        $aea236adfe947986$var$setValueDropDownNavigation(el.getAttribute("data-element"));
    });
    el.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $aea236adfe947986$var$navigationMegaDropdownEl.style.display = "none";
    });
    $aea236adfe947986$var$navigationMegaDropdownEl.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $aea236adfe947986$var$navigationMegaDropdownEl.style.display = "flex";
    });
    $aea236adfe947986$var$navigationMegaDropdownEl.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $aea236adfe947986$var$navigationMegaDropdownEl.style.display = "none";
    });
});

});
parcelRegister("dEKS9", function(module, exports) {
module.exports = new URL("battery-charging.ba1b1745.webp", import.meta.url).toString();

});

parcelRegister("1ICF9", function(module, exports) {
module.exports = new URL("settings-02.d69d69bd.webp", import.meta.url).toString();

});

parcelRegister("62f2s", function(module, exports) {
module.exports = new URL("life-buoy.285e728c.webp", import.meta.url).toString();

});

parcelRegister("7QJiP", function(module, exports) {
module.exports = new URL("people.d532b8d6.webp", import.meta.url).toString();

});

parcelRegister("7EaWj", function(module, exports) {
module.exports = new URL("grid.f0e29351.webp", import.meta.url).toString();

});

parcelRegister("lXlin", function(module, exports) {
module.exports = new URL("box.2a34708a.webp", import.meta.url).toString();

});


parcelRegister("lAems", function(module, exports) {

var $g1prE = parcelRequire("g1prE");
const $fb68199a103da584$var$testimonialCardParent = document.querySelector(".swiper-wrapper.testimonial-cards");
(0, $g1prE.default).forEach((testimonial)=>{
    const testimonialCardEl = document.querySelector('[data-element="testimonial-card-slider"]').cloneNode(true);
    testimonialCardEl.querySelector('[data-element="testimonial-people-name"]').textContent = testimonial.name;
    testimonialCardEl.querySelector('[data-element="testimonial-position"]').textContent = testimonial.position;
    testimonialCardEl.querySelector('[data-element="testimonial-text-all"]').innerHTML = testimonial.testimonyTextAll;
    testimonialCardEl.querySelector('[data-element="testimonial-text-less"]').innerHTML = testimonial.testimonyTextLess ?? testimonial.testimonyText;
    testimonialCardEl.querySelector('[data-element="testimonial-company-logo"]').src = testimonial.companyLogo;
    testimonialCardEl.querySelector('[data-element="testimonial-company-logo"]').parentElement.classList.add(testimonial.companyLogoClass);
    testimonialCardEl.querySelector('[data-element="testimonial-photo-small"]').srcset = testimonial.photo.mobile;
    testimonialCardEl.querySelector('[data-element="testimonial-photo-large"]').src = testimonial.photo.desktop;
    $fb68199a103da584$var$testimonialCardParent.appendChild(testimonialCardEl);
});
document.querySelectorAll('[data-element="testimonial-card-slider"]')[0].remove();
document.querySelectorAll(".testimonial-content .showMoreBtn").forEach((el)=>{
    el.addEventListener("click", ()=>{
        const testimonialContent = el.parentElement.parentElement;
        testimonialContent.querySelector('[data-element="testimonial-text-all"]').style.display = "inline";
        testimonialContent.querySelector('[data-element="testimonial-text-less"]').style.display = "none";
    });
});
document.querySelectorAll(".testimonial-content .showLessBtn").forEach((el)=>{
    el.addEventListener("click", ()=>{
        const testimonialContent = el.parentElement.parentElement;
        testimonialContent.querySelector('[data-element="testimonial-text-all"]').style.display = "none";
        testimonialContent.querySelector('[data-element="testimonial-text-less"]').style.display = "inline";
    });
});

});
parcelRegister("g1prE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $baa07a2da563b7cf$export$2e2bcd8739ae039; });




























const $baa07a2da563b7cf$var$testimonials = [
    {
        name: "Neo Christodoulou",
        photo: {
            mobile: new URL((parcelRequire("7HH6J"))),
            tablet: new URL((parcelRequire("fQXxj"))),
            desktop: new URL((parcelRequire("fQXxj")))
        },
        position: "Founder, Smashing Plates",
        companyLogo: new URL((parcelRequire("3xrfP"))),
        companyLogoClass: "smashing-plates",
        testimonyText: "Wenodo have been a long-standing close partner. Their holistic approach in managing our accounts has been invaluable to our organization. Not only do they handle all of our accounting needs, but they also expertly manage our HR/payroll department and also their customized cloud-based real-time analytics and reports has provided us with valuable insights and data-driven decision-making."
    },
    {
        name: "Johnny Smith and Daniel Willis",
        photo: {
            mobile: new URL((parcelRequire("aNEv1"))),
            tablet: new URL((parcelRequire("eEPT9"))),
            desktop: new URL((parcelRequire("eEPT9")))
        },
        position: "Co Founder, Luca Restaurant",
        companyLogo: new URL((parcelRequire("iTpqM"))),
        companyLogoClass: "luca",
        testimonyText: "Wenodo's team is exceptional! Their profound knowledge of the hospitality industry and their friendly customer service have been invaluable to our business. Their expertise in the intricacies of our industry coupled with their approachable and supportive service have made working with them a true pleasure. They understand our needs and offer tailored solutions, making a significant difference in our operations."
    },
    {
        name: "Wonchul Park",
        photo: {
            mobile: new URL((parcelRequire("5UGtP"))),
            tablet: new URL((parcelRequire("jB2T7"))),
            desktop: new URL((parcelRequire("jB2T7")))
        },
        position: "Michelin Star Chef, Sollip",
        companyLogo: new URL((parcelRequire("6Owqq"))),
        companyLogoClass: "sollip",
        testimonyText: "Wenodo have been a long-standing close partner. Their holistic approach in managing our accounts has been invaluable to our organization. Not only do they handle all of our accounting needs, but they also expertly manage our HR/payroll department and also their customized cloud-based real-time analytics and reports has provided us with valuable insights and data-driven decision-making."
    },
    {
        name: "George\xa0Kakavitsa",
        photo: {
            mobile: new URL((parcelRequire("esJeA"))),
            tablet: new URL((parcelRequire("9096f"))),
            desktop: new URL((parcelRequire("9096f")))
        },
        position: "Assistant Restaurant Manager, L\xedo London",
        companyLogo: new URL((parcelRequire("iNJPw"))),
        companyLogoClass: "lio",
        testimonyText: "Wenodo's HR/Rota SaaS solution has revolutionized our workforce management. Its intuitive interface simplifies employee's lifecycle, shift scheduling and communication. With robust reporting, we gain valuable insights for informed decisions. Exceptional customer support ensures smooth operations. It's a game-changer for our Restaurant operation, enhancing efficiency and employee engagement. Highly recommended!"
    },
    {
        name: "Dominic Hamdy",
        photo: {
            mobile: new URL((parcelRequire("7fLN9"))),
            tablet: new URL((parcelRequire("3Kl3R"))),
            desktop: new URL((parcelRequire("3Kl3R")))
        },
        position: "Founder, HAM Restaurants",
        companyLogo: new URL((parcelRequire("7DE1Y"))),
        companyLogoClass: "ham",
        testimonyText: "WENODO has helped to grow and streamline our business from day one. We can now make financial and strategic decisions based on data we can trust. Their personal attitude and enthusiasm to go the extra mile is invaluable, but it's their modern approach to accounting that has \xa0propelled us forward.\xa0"
    },
    // {
    //   name: 'Tarek Farah',
    //   photo: {
    //     mobile: new URL('../image/testimonial-tarek-farah-mobile.png?as=webp', import.meta.url),
    //     tablet: new URL('../image/testimonial-tarek-farah.png?as=webp', import.meta.url),
    //     desktop: new URL('../image/testimonial-tarek-farah.png?as=webp', import.meta.url)
    //   },
    //   position: 'Founder and CEO, Aline Lebanese Kitchen',
    //   companyLogo: new URL(
    //     '../image/aline-company.png',
    //     import.meta.url
    //   ),
    //   companyLogoClass: 'aline',
    //   testimonyText: 'I have been gladly working with the Wenodo team for nearly 10 years. They are not just professional, experienced, and knowledgeable accountants but also great consultants who offer so much value and advice on all levels of hospitality. I cannot imagine any of our future projects being developed without Wenodo by our side!'
    // },
    {
        name: "David Bellaiche",
        photo: {
            mobile: new URL((parcelRequire("8Ixig"))),
            tablet: new URL((parcelRequire("8usPw"))),
            desktop: new URL((parcelRequire("8usPw")))
        },
        position: "Co-Founder, NAC London",
        companyLogo: new URL((parcelRequire("jvVwZ"))),
        companyLogoClass: "nac",
        testimonyText: "Wenodo's daily, weekly, and monthly KPIs and analytics has been so critical for our business. Their insightful Dashboard and reports have allowed us to maximize profits. With these detailed metrics, we're empowered to make timely and informed decisions, contributing significantly to\xa0our\xa0success."
    },
    {
        name: "Gabriel Cohen-Elia",
        photo: {
            mobile: new URL((parcelRequire("jmWdC"))),
            tablet: new URL((parcelRequire("4UIas"))),
            desktop: new URL((parcelRequire("4UIas")))
        },
        position: "Co-Founder, Cr\xe8me London",
        companyLogo: new URL((parcelRequire("030vB"))),
        companyLogoClass: "creme",
        testimonyText: "Partnering with Wenodo has revolutionized how we manage our finances and operations. Their specialized accounting and bookkeeping solutions have not only streamlined our processes but also brought unparalleled clarity to our financial landscape. Wenodo's dedicated support team is always responsive and knowledgeable, making them an integral part of our success. For anyone in hospitality seeking reliability and expertise, Wenodo is the\xa0clear\xa0choice."
    }
];
var $baa07a2da563b7cf$export$2e2bcd8739ae039 = $baa07a2da563b7cf$var$testimonials;

});
parcelRegister("7HH6J", function(module, exports) {
module.exports = new URL("testimoni-neo-mobile.63e4b5d3.webp", import.meta.url).toString();

});

parcelRegister("fQXxj", function(module, exports) {
module.exports = new URL("testimoni-neo.dcffeccd.webp", import.meta.url).toString();

});

parcelRegister("3xrfP", function(module, exports) {
module.exports = new URL("smashing-plates.7136aa41.webp", import.meta.url).toString();

});

parcelRegister("aNEv1", function(module, exports) {
module.exports = new URL("testimoni-johny-mobile.dfee8b00.webp", import.meta.url).toString();

});

parcelRegister("eEPT9", function(module, exports) {
module.exports = new URL("testimoni-johny.331dada6.webp", import.meta.url).toString();

});

parcelRegister("iTpqM", function(module, exports) {
module.exports = new URL("luca-company.ebbca258.webp", import.meta.url).toString();

});

parcelRegister("5UGtP", function(module, exports) {
module.exports = new URL("testimonial-wonchul-mobile.82623782.webp", import.meta.url).toString();

});

parcelRegister("jB2T7", function(module, exports) {
module.exports = new URL("testimonial-wonchul.e435ed72.webp", import.meta.url).toString();

});

parcelRegister("6Owqq", function(module, exports) {
module.exports = new URL("sollip-company.c4e68d8a.png", import.meta.url).toString();

});

parcelRegister("esJeA", function(module, exports) {
module.exports = new URL("testimonial-george-mobile.ba4357c1.webp", import.meta.url).toString();

});

parcelRegister("9096f", function(module, exports) {
module.exports = new URL("testimonial-george.3f5b8295.webp", import.meta.url).toString();

});

parcelRegister("iNJPw", function(module, exports) {
module.exports = new URL("lio-company.51d21251.png", import.meta.url).toString();

});

parcelRegister("7fLN9", function(module, exports) {
module.exports = new URL("testimonial-dominic-hamdy-mobile.795bc261.webp", import.meta.url).toString();

});

parcelRegister("3Kl3R", function(module, exports) {
module.exports = new URL("testimonial-dominic-hamdy.7a029c2b.webp", import.meta.url).toString();

});

parcelRegister("7DE1Y", function(module, exports) {
module.exports = new URL("ham-company.5f8ce858.png", import.meta.url).toString();

});

parcelRegister("8Ixig", function(module, exports) {
module.exports = new URL("testimonial-david-bellaiche-mobile.c3669d3d.webp", import.meta.url).toString();

});

parcelRegister("8usPw", function(module, exports) {
module.exports = new URL("testimonial-david-bellaiche.e487dcaf.webp", import.meta.url).toString();

});

parcelRegister("jvVwZ", function(module, exports) {
module.exports = new URL("nac-company.269e0029.png", import.meta.url).toString();

});

parcelRegister("jmWdC", function(module, exports) {
module.exports = new URL("testimonial-gabriel-mobile.45a97971.webp", import.meta.url).toString();

});

parcelRegister("4UIas", function(module, exports) {
module.exports = new URL("testimonial-gabriel.ad41ee07.webp", import.meta.url).toString();

});

parcelRegister("030vB", function(module, exports) {
module.exports = new URL("creme-company.ca71e074.png", import.meta.url).toString();

});



parcelRegister("j1fKb", function(module, exports) {
const $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl = document.querySelector(".preferencePrivacy-popup");
const $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl = document.querySelector(".preferencePrivacy-popupDetail");
const $dd8a52bd9dba4c43$var$isCookies = document.cookie.split(";").filter((value)=>value === "_cookies=guest")[0] === "_cookies=guest" || document.cookie.split(";").filter((value)=>value === " _cookies=guest")[0] === " _cookies=guest";
if ($dd8a52bd9dba4c43$var$isCookies) $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.remove("show");
else $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.add("show");
// Cookies Button
document.querySelector(".btn-cookies").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.add("show");
// document.querySelector('.cookies-alert-popup').style.display = 'block'
});
document.querySelector(".cookies-accept-btn").addEventListener("click", ()=>{
    // document.querySelector('.cookies-alert-popup').style.display = 'none'
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.querySelector(".btn.preferencePrivacy-popup--closeBtn").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.remove("show");
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.remove("show");
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.classList.add("show");
// document.cookie = '_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC'
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
document.querySelector(".btn.cookies-learn-more-btn").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.add("show");
    document.querySelector(".cookies-alert-popup").style.display = "none";
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.querySelector(".btn.preferencePrivacy-popupDetail--closeBtn").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.classList.remove("show");
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--preferencePrivacy-popupDetailConfirmPreference").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});

});

var $e73dd7d00ec5d463$exports = {};

(parcelRequire("3ueMA")).register(new URL("", import.meta.url).toString(), JSON.parse('["IEJh1","power-insight.f9ecc6b9.js","6caN2","battery-charging.ba1b1745.webp","cXG1D","settings-02.d69d69bd.webp","a8sKm","life-buoy.285e728c.webp","bjrUj","people.d532b8d6.webp","fkH4J","grid.f0e29351.webp","83Igj","box.2a34708a.webp","9Y1lA","testimoni-neo-mobile.63e4b5d3.webp","8KDDW","testimoni-neo.dcffeccd.webp","cWSbq","smashing-plates.7136aa41.webp","cMUme","testimoni-johny-mobile.dfee8b00.webp","k6JM1","testimoni-johny.331dada6.webp","57Uq8","luca-company.ebbca258.webp","iwFLi","testimonial-wonchul-mobile.82623782.webp","5rJO0","testimonial-wonchul.e435ed72.webp","n2loJ","sollip-company.c4e68d8a.png","59kaK","testimonial-george-mobile.ba4357c1.webp","3hhKd","testimonial-george.3f5b8295.webp","7Epdw","lio-company.51d21251.png","gNGks","testimonial-dominic-hamdy-mobile.795bc261.webp","vbdTF","testimonial-dominic-hamdy.7a029c2b.webp","8oJQA","ham-company.5f8ce858.png","9K1jB","testimonial-david-bellaiche-mobile.c3669d3d.webp","hOqIG","testimonial-david-bellaiche.e487dcaf.webp","15Hx9","nac-company.269e0029.png","jXZmL","testimonial-gabriel-mobile.45a97971.webp","1H8PE","testimonial-gabriel.ad41ee07.webp","7jDMh","creme-company.ca71e074.png"]'));

parcelRequire("1VgMz");
parcelRequire("eZzoa");
parcelRequire("lAems");
parcelRequire("j1fKb");
/* eslint-disable no-undef */ // eslint-disable-next-line no-unused-vars
const $5ff4b91840460624$var$swiper = new Swiper(".swiper-testimonial", {
    // Optional parameters
    // direction: 'vertical',
    loop: false,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 32,
    // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination'
    // },
    // Navigation arrows
    navigation: {
        nextEl: ".swiper-testimonial-next-button",
        prevEl: ".swiper-testimonial-prev-button"
    },
    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar'
    // }
    breakpoints: {
        1200: {
            slidesPerView: 1.2
        }
    }
});
const $5ff4b91840460624$var$productPowerInsightsEl = document.querySelector(".product__power-insight");
$5ff4b91840460624$var$productPowerInsightsEl.querySelectorAll(".product__power-insight--tab").forEach((tabElement)=>{
    tabElement.addEventListener("click", ()=>{
        $5ff4b91840460624$var$productPowerInsightsEl.querySelectorAll(".product__power-insight--tab").forEach((el)=>{
            el.classList.remove("active");
        });
        $5ff4b91840460624$var$productPowerInsightsEl.querySelectorAll(".product__power-insight--content-item").forEach((el)=>{
            el.style.display = "none";
            if (tabElement.getAttribute("data-tab") === el.getAttribute("data-tab")) el.style.display = "flex";
        });
        console.log(tabElement.getAttribute("data-tab"));
        tabElement.classList.add("active");
    });
});
const $5ff4b91840460624$var$preHeadingIcon = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="16" fill="#1DCA5D"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8337 14.2283C13.2713 13.8583 14.3337 12.5532 14.3337 11C14.3337 9.15905 12.8413 7.66667 11.0003 7.66667C9.15938 7.66667 7.66699 9.15905 7.66699 11C7.66699 12.5532 8.7293 13.8583 10.167 14.2283V23.5C10.167 23.9602 10.5401 24.3333 11.0003 24.3333C11.4606 24.3333 11.8337 23.9602 11.8337 23.5V14.2283Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.667 21C17.667 19.4468 18.7293 18.1417 20.167 17.7717V12.6667C20.167 12.4457 20.0792 12.2337 19.9229 12.0774C19.7666 11.9211 19.5547 11.8333 19.3337 11.8333H16.8337C16.3734 11.8333 16.0003 11.4602 16.0003 11C16.0003 10.5398 16.3734 10.1667 16.8337 10.1667H19.3337C19.9967 10.1667 20.6326 10.4301 21.1014 10.8989C21.5703 11.3677 21.8337 12.0036 21.8337 12.6667V17.7717C23.2713 18.1417 24.3337 19.4468 24.3337 21C24.3337 22.8409 22.8413 24.3333 21.0003 24.3333C19.1594 24.3333 17.667 22.8409 17.667 21Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.6667 21C17.6667 19.4468 18.729 18.1417 20.1667 17.7717V12.6667C20.1667 12.4457 20.0789 12.2337 19.9226 12.0774C19.7663 11.9211 19.5543 11.8333 19.3333 11.8333H16.8333C16.3731 11.8333 16 11.4602 16 11C16 10.5398 16.3731 10.1667 16.8333 10.1667H19.3333C19.9964 10.1667 20.6323 10.4301 21.1011 10.8989C21.5699 11.3677 21.8333 12.0036 21.8333 12.6667V17.7717C23.271 18.1417 24.3333 19.4468 24.3333 21C24.3333 22.8409 22.8409 24.3333 21 24.3333C19.1591 24.3333 17.6667 22.8409 17.6667 21Z" fill="#77DF9E"/>
</svg>`;
document.querySelector(".apps__power-insight--left-preHeading-icon").innerHTML += $5ff4b91840460624$var$preHeadingIcon;
document.querySelector(".testimonial-slider-preHeading .services__icon").innerHTML += $5ff4b91840460624$var$preHeadingIcon;
document.querySelector(".faq__feature-consulting--preHeading-icon").innerHTML += $5ff4b91840460624$var$preHeadingIcon;
// Arrow Up Icon Button
const $5ff4b91840460624$var$arrowUpIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.83301 14.1667L14.1663 5.83334M14.1663 5.83334H5.83301M14.1663 5.83334V14.1667" stroke="#05A6F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
// document.querySelector('.btn-learn-more').innerHTML += arrowUpIcon
document.querySelector(".btn.btn-book-demo").innerHTML += $5ff4b91840460624$var$arrowUpIcon;
// FAQ
document.querySelectorAll(".faq__feature-consulting--faqItem").forEach((el)=>{
    el.querySelector(".faq__feature-consulting--faqItem-header").addEventListener("click", ()=>{
        if (el.classList.contains("active")) el.classList.remove("active");
        else {
            document.querySelectorAll(".faq__feature-consulting--faqItem").forEach((el2)=>{
                el2.classList.remove("active");
            });
            el.classList.add("active");
        }
    });
});
const $5ff4b91840460624$var$chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".link-item .arrow-down").forEach((el)=>{
    el.innerHTML += $5ff4b91840460624$var$chevronDownIcon;
});
const $5ff4b91840460624$var$hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelector(".btn-hamburger").innerHTML += $5ff4b91840460624$var$hamburgerIcon;
// Create the observer like the examples above
const $5ff4b91840460624$var$observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) entry.target.classList.add("animate__fadeInUp");
    // entry.target.classList.remove('animate__animated')
    });
});
// Get multiple elements instead of a single one using "querySelectorAll"
const $5ff4b91840460624$var$squares = document.querySelectorAll(".animated-js");
// Loop over the elements and add each one to the observer
$5ff4b91840460624$var$squares.forEach((element)=>$5ff4b91840460624$var$observer.observe(element));
const $5ff4b91840460624$var$dropdownProduct = document.querySelector('[data-element="dropdown-product"]');
$5ff4b91840460624$var$dropdownProduct.querySelector('[data-element="dropdown-btn"]').addEventListener("click", (el)=>{
    if ($5ff4b91840460624$var$dropdownProduct.querySelector('[data-element="dropdown-content"]').classList.contains("hide")) {
        $5ff4b91840460624$var$dropdownProduct.querySelector('[data-element="dropdown-content"]').classList.remove("hide");
        $5ff4b91840460624$var$dropdownProduct.querySelector('[data-element="dropdown-btn-arrow"]').style.rotate = "180deg";
    } else {
        $5ff4b91840460624$var$dropdownProduct.querySelector('[data-element="dropdown-content"]').classList.add("hide");
        $5ff4b91840460624$var$dropdownProduct.querySelector('[data-element="dropdown-btn-arrow"]').style.rotate = "0deg";
    }
});
$5ff4b91840460624$var$dropdownProduct.querySelectorAll('[data-element="dropdown-btn-item"]').forEach((elBtn)=>{
    elBtn.addEventListener("click", (ev)=>{
        const textSelection = elBtn.querySelector("p").textContent;
        $5ff4b91840460624$var$dropdownProduct.querySelector('[data-element="dropdown-btn"] p').textContent = textSelection;
        $5ff4b91840460624$var$dropdownProduct.querySelector('[data-element="dropdown-content"]').classList.add("hide");
        $5ff4b91840460624$var$dropdownProduct.querySelector('[data-element="dropdown-btn-arrow"]').style.rotate = "0deg";
        $5ff4b91840460624$var$productPowerInsightsEl.querySelectorAll(".product__power-insight--content-item").forEach((elContent)=>{
            elContent.style.display = "none";
            if (elBtn.getAttribute("data-select") === elContent.getAttribute("data-tab")) elContent.style.display = "flex";
        });
    });
});


//# sourceMappingURL=power-insight.f9ecc6b9.js.map
